import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  CreateInviteOptions,
  CreateInviteResponse,
  SubjectInviteAssignments,
  createInvite as universalCreateInvite,
} from './identity-invites-v1-account-invite-account-invites.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/user-management' };

export function createInvite(httpClient: HttpClient): CreateInviteSignature {
  return (
    subjectsAssignments: SubjectInviteAssignments[],
    options?: CreateInviteOptions
  ) =>
    universalCreateInvite(
      subjectsAssignments,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateInviteSignature {
  /**
   * Creates and sends invite emails to a list of potential team members, inviting them to become team members of the requesting account.
   * The invites may be limited to a specific resource (site or other asset).
   * Maximum 50 invitees can be specified per call.
   *
   * > **Important**: This call requires an account level API key and cannot be authenticated with the standard authorization header. API keys are currently available to selected beta users only.
   * @param - Array of potential team members' email addresses and their corresponding assignments (how they will be assigned when they accept the invite).
   * @param - Filter options.
   */
  (
    subjectsAssignments: SubjectInviteAssignments[],
    options?: CreateInviteOptions
  ): Promise<
    NonNullablePaths<
      CreateInviteResponse,
      | `successfulInvites`
      | `successfulInvites.${number}._id`
      | `successfulInvites.${number}.accountId`
      | `successfulInvites.${number}.email`
      | `successfulInvites.${number}.role`
      | `successfulInvites.${number}.inviterId`
      | `successfulInvites.${number}.status`
      | `successfulInvites.${number}.acceptLink`
      | `successfulInvites.${number}.inviterAccountId`
      | `failedInvites`
      | `failedInvites.${number}.subjectEmail`
      | `failedInvites.${number}.errorMessage`,
      4
    >
  >;
}

export {
  AcceptAccountInviteRequest,
  AcceptAccountInviteResponse,
  AccountInvite,
  AccountInviteRequest,
  AccountInviteResponse,
  AccountResourceContext,
  BulkAccountInviteRequest,
  BulkAccountInviteResponse,
  Condition,
  ConditionOperator,
  ConditionOperatorOperatorsOneOf,
  ConditionType,
  ConditionTypeOfOneOf,
  ConditionValue,
  ConditionValueValueOneOf,
  CreateInviteOptions,
  CreateInviteRequest,
  CreateInviteResponse,
  DependOnOperator,
  EnvironmentCondition,
  EnvironmentConditionConditionOneOf,
  EqualOperator,
  ExperimentCondition,
  ExperimentOperator,
  FullNameResource,
  FullNameResourceResourceContextOneOf,
  GetAccountInviteRequest,
  GetAccountInviteResponse,
  GetAccountInvitesRequest,
  GetAccountInvitesResponse,
  InviteAssignment,
  InviteFailure,
  InviteResourceAssignment,
  InviteStatus,
  JoinedCondition,
  JoinedConditionOperator,
  LikeOperator,
  OrganizationResourceContext,
  ParseAccountInviteTokenRequest,
  ParseAccountInviteTokenResponse,
  PolicyCondition,
  ResendAccountInviteRequest,
  Resource,
  RevokeAccountInviteRequest,
  RevokeAccountInviteResponse,
  SimpleCondition,
  SimpleConditionOperator,
  SimpleConditionValue,
  SimpleConditionValueValueOneOf,
  SiteResourceContext,
  Subject,
  SubjectContext,
  SubjectContextType,
  SubjectInviteAssignments,
  SubjectType,
  UpdateAccountInviteAssignmentsRequest,
  UpdateAccountInviteAssignmentsResponse,
  UpdateAccountInviteRequest,
  UpdateAccountInviteResponse,
} from './identity-invites-v1-account-invite-account-invites.universal.js';
